// Group type
export enum EGroupType {
  schedule = 'schedule',
  usageLimit = 'usageLimit',
  focusTime = 'focusTime',
}

// Group color
// TODO: complete full list
export enum EGroupColor {
  red500 = 'red500',
  red400 = 'red400',
}

export type GroupIcon = string;

// Time interval
export interface GroupRuleTimeInterval {
  start: string; // e.g., "11:00"
  end: string; // e.g., "12:00"
}

// Schedule
interface GroupRuleSchedule {
  activeDays: number[];
  timeIntervals: GroupRuleTimeInterval[];
}

// Focus time rule config
export interface GroupRuleFocus {
  workTimeOverrideMins: number;
  breakTimeOverrideMins: number;
  cycles: number;
}

// Usage limit rule config
export interface GroupRuleUsageLimit {
  blocked: boolean;
  dailyLimit: number;
  gracePeriod: boolean;
}

// Group item type
export enum EGroupItemType {
  website = 'website',
  category = 'category',
  keyword = 'keyword',
  appIos = 'appIos',
  appAndroid = 'appAndroid',
}

export interface SaveGroupItemsDto {
  items: GroupItem[];
}

export interface GroupItem {
  itemType: EGroupItemType;
  itemValue: string;
}

// Main group base class
export interface Group {
  id: string;
  name: string | null;
  type: EGroupType;
  icon?: GroupIcon;
  color?: EGroupColor;
  updatedAt: number;
  createdAt: number;
  enabled: boolean;
  schedule?: GroupRuleSchedule;
  usageLimit?: GroupRuleUsageLimit;
  focusTime?: GroupRuleFocus;
  items: GroupItem[];
  originDeviceId: string | null;
}
